import Template from "ui/Template";
import {i18n} from "ui/i18n";
import Tools from "ui/editor/toolboxes/tools/Tools";
import ScalePicker from "ui/editor/dialogs/scale-picker/ScalePicker";
import AlphaPicker from "ui/editor/dialogs/alpha-picker/AlphaPicker";
import layerToolsView from './layer-tools.handlebars';
import CanvasSkew from "ui/canvas/transforms/CanvasSkew";
import CanvasFlip from "ui/canvas/transforms/CanvasFlip";
import CanvasScale from "ui/canvas/transforms/CanvasScale";
import CanvasAlpha from "ui/canvas/transforms/CanvasAlpha";
import CanvasWaterWaves from "ui/canvas/transforms/CanvasWaterWaves";
import MovementSetup from "ui/editor/dialogs/movement-setup/MovementSetup";
import CanvasMove from "ui/canvas/transforms/CanvasMove";
import RotateSetup from "ui/editor/dialogs/rotate-setup/RotateSetup";
import CanvasRotate from "ui/canvas/transforms/CanvasRotate";
import CanvasBlur from "ui/canvas/transforms/CanvasBlur";
import BlurSetup from "ui/editor/dialogs/blur-setup/BlurSetup";
import HSLRotatorSetup from "ui/editor/dialogs/hsl-rotator/HSLRotatorSetup";
import CanvasHSLRotator from "ui/canvas/transforms/CanvasHueRotator";
import SharpnessSetup from "ui/editor/dialogs/sharpness-setup/SharpnessSetup";
import CanvasSharpen from "ui/canvas/transforms/CanvasSharpen";
import SwirlSetup from "../../dialogs/swirl-props/SwirlSetup.js";
import CanvasSwirl from "../../../canvas/transforms/CanvasSwirl.js";

/**
 * Canvas Layer Transform Tools
 */
export default class LayerTools extends Tools {
	/**
	 * Class constructor
	 *
	 * @param {Object} [options]
	 */
	constructor(options = {}) {
		super(Object.assign({
			title: i18n('title.layer-tools'),
			body: new Template(layerToolsView)
				.createElement()
		}, options));
	}

	/**
	 * Returns selected tool value
	 *
	 * @override
	 * @returns {string}
	 */
	getSelectedTool() {
		return '';
	}

	/**
	 * Sets current tool
	 *
	 * @override
	 * @param {string} name
	 * @returns {void}
	 */
	selectTool(name) {
		const sel = this.scene.canvas.getFramesSelection();
		const hasSelection = sel.from !== sel.to;
		switch (name) {
			case 'skew-left':
				this.scene.canvas.transformLayer(new CanvasSkew(true, false)).then();
				break;
			case 'skew-right':
				this.scene.canvas.transformLayer(new CanvasSkew(false, false)).then();
				break;
			case 'flip-h':
				this.scene.canvas.transformLayer(new CanvasFlip(false)).then();
				break;
			case 'flip-v':
				this.scene.canvas.transformLayer(new CanvasFlip(true)).then();
				break;
			case 'scale':
				(new ScalePicker(hasSelection)).getResultPromise().then((res) => {
					if (res === null) {
						return;
					}
					this.scene.canvas.transformLayer(
						new CanvasScale(res.scaleFrom, res.scaleTo, res.xAxis, res.yAxis, res.smooth)
					).then();
				});
				break;
			case 'alpha':
				(new AlphaPicker(hasSelection)).getResultPromise().then((res) => {
					if (res === null) {
						return;
					}
					this.scene.canvas.transformLayer(new CanvasAlpha(res.alphaFrom, res.alphaTo)).then();
				});
				break;
			case 'water-waves':
				this.scene.canvas.transformLayer(new CanvasWaterWaves()).then();
				break;
			case 'blur':
				(new BlurSetup(hasSelection)).getResultPromise().then((res) => {
					this.scene.canvas.transformLayer(new CanvasBlur(res.radiusFrom, res.radiusTo)).then();
				});
				break;
			case 'sharpen':
				(new SharpnessSetup()).getResultPromise().then((res) => {
					this.scene.canvas.transformLayer(new CanvasSharpen(res)).then();
				});
				break;
			case 'move':
				(new MovementSetup()).getResultPromise().then((res) => {
					if (res === null) {
						return;
					}
					this.scene.canvas.transformLayer(new CanvasMove(res.angle, res.distance, res.isInteger)).then();
				});
				break;
			case 'rotate':
				(new RotateSetup(hasSelection)).getResultPromise().then((res) => {
					if (res === null) {
						return;
					}
					this.scene.canvas.transformLayer(new CanvasRotate(res.angleFrom, res.angleTo)).then();
				});
				break;
			case 'hsl':
				(new HSLRotatorSetup()).getResultPromise().then((res) => {
					if (res === null) {
						return;
					}
					this.scene.canvas.transformLayer(
						new CanvasHSLRotator(res.hueAngleDeg, res.saturatePercent, res.lightlessPercent)
					).then();
				});
				break;
			case 'swirl':
				(new SwirlSetup(hasSelection)).getResultPromise().then((res) => {
					if (res === null) {
						return;
					}
					this.scene.canvas.transformLayer(new CanvasSwirl(res.twistsFrom, res.twistsTo)).then();
				});
				break;
		}
	}
}
